import React, { Suspense } from "react";
import { Navigate, Outlet } from "react-router";
import type { RouteObject } from "react-router";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import NotFound from "../../shared/components/NotFound";
import LoadingScreen from "../../shared/components/Loading";
import { lazyWithRetry } from "../../shared/components/ChunkErrorBoundary";
import Layout from "../../shared/components/redesigned/Layout";
import type { SidebarItem } from "../../shared/components/redesigned/Sidebar";
import useTranslation from "../../shared/hooks/useTranslation";
import RequireRole, { MANAGER_ROLES } from "../auth/components/RequireRole";

const UnitsScreen = lazyWithRetry(() => import("./routes/Units"));
const UnitShow = lazyWithRetry(() => import("./routes/Units/components/UnitShow"));

const ManagerLayout = () => {
    const { t } = useTranslation();
    const navItems: SidebarItem[] = [
        {
            to: "/management/units",
            icon: faFileAlt,
            label: t("nav.manager.skipped_documents"),
        },
    ];

    return (
        <Layout navItems={navItems}>
            <Suspense fallback={<LoadingScreen />}>
                <Outlet />
            </Suspense>
        </Layout>
    );
};

export const managementRoutes: RouteObject[] = [
    {
        element: <RequireRole roles={MANAGER_ROLES} />,
        children: [
            {
                element: <ManagerLayout />,
                children: [
                    { index: true, element: <Navigate to="units" replace /> },
                    {
                        path: "units",
                        element: <UnitsScreen />,
                        children: [{ path: ":unitId", element: <UnitShow /> }],
                    },
                    { path: "*", element: <NotFound /> },
                ],
            },
        ],
    },
];
